import account from '@/net_url/account_net_url'; //账号

import aduio from '@/net_url/aduio_net_url'; //音频

import aduio_video from '@/net_url/aduio_video_net_url'; //音频、视频公共接口

import dept_ry from '@/net_url/dept_ry_url'; //部门成员

import dept from '@/net_url/dept_url'; //部门

import location from '@/net_url/location_url'; //定位

import meet from '@/net_url/meet_url'; //会议

import message from '@/net_url/message_url'; //短信

import record from '@/net_url/record_url'; //录音录像

import video from '@/net_url/video_net_url'; //视频

export const server = 'http://10.249.4.152:8080'; //内网服务地址

export const cometd_server = '/scooper-msg-queue/cometd'; //

export { account, aduio, aduio_video, dept_ry, dept, location, meet, message, record, video };